import { SimpleBoundingBox } from "@nova/constants"

export const REGION_CELL_DEGREES = 30

const range = (start: number, end: number) =>
    Array.from({ length: end - start + 1 }, (_, i) => start + i)

export const createRegionGrid = (cellDegrees: number) => {
    const cols = 360 / cellDegrees
    const rows = 180 / cellDegrees

    const colOf = (lng: number) => Math.floor((lng + 180) / cellDegrees)
    const rowOf = (lat: number) => Math.floor((lat + 90) / cellDegrees)

    const regionIdForPoint = (lat: number, lng: number) => `${colOf(lng)}:${rowOf(lat)}`

    const regionIdsForBounds = ({ minLat, maxLat, minLng, maxLng }: SimpleBoundingBox) => {
        const rowStart = Math.max(0, rowOf(minLat))
        const rowEnd = Math.min(rows - 1, rowOf(maxLat))

        const colStart = colOf(minLng)
        const colEnd = colOf(maxLng)
        const columns =
            colStart <= colEnd
                ? range(colStart, colEnd)
                : [...range(colStart, cols - 1), ...range(0, colEnd)]

        const ids: string[] = []
        for (const col of columns) {
            for (let row = rowStart; row <= rowEnd; row++) {
                ids.push(`${col}:${row}`)
            }
        }
        return ids
    }

    return { cellDegrees, regionIdForPoint, regionIdsForBounds }
}

const defaultGrid = createRegionGrid(REGION_CELL_DEGREES)

export const regionIdForPoint = defaultGrid.regionIdForPoint
export const regionIdsForBounds = defaultGrid.regionIdsForBounds
